<script>
import AppDialog from '@/components/UI/AppDialog.vue'
import AppToast from '@/components/UI/AppToast.vue'
import MaintenanceBanner from '@/components/MaintenanceBanner.vue'

export default {
	name: 'App',
	components: {
		AppDialog,
		AppToast,
		MaintenanceBanner,
	},
	metaInfo() {
		return {
			title: this.$t('site.logo.title'),
			meta: [
				{
					vmid: 'description',
					name: 'description',
					content: this.$t('site.logo.desc'),
				},
				{
					vmid: 'og:title',
					property: 'og:title',
					content: this.$t('site.logo.title'),
				},
				{
					vmid: 'og:description',
					property: 'og:description',
					content: this.$t('site.logo.desc'),
				},
			],
		}
	},
	data() {
		return {
			namePagePer: false,
			mobileStatus: false,
		}
	},
	computed: {
		classPage: function () {
			return this.namePageFunc()
		},
	},
	methods: {
		namePageFunc() {
			if (this.$route.name != 'Home') {
				return (this.namePagePer = false)
			} else {
				return (this.namePagePer = true)
			}
		},
		mobileActive(status) {
			this.mobileStatus = status
		},
	},
	head: {
		// To use "this" in the component, it is necessary to return the object through a function
		title: function () {
			return {
				inner: this.$t('site.logo.title'),
			}
		},
	},
	watch: {},
}
</script>

<template>
	<div id="app" v-bind:class="{ 'home-page': classPage, mobile__active: mobileStatus }">
		<!-- <MaintenanceBanner /> -->
		<!--  class="wrapper"  -->
		<router-view />

		<AppDialog />
		<AppToast />
	</div>
</template>

<style>
@import './assets/css/vue-multiselect.min.css';
@import './assets/css/v-tooltip.css';

@import './assets/css/vuetify.css';
@import './assets/css/bootstrap.min.css';

@import './assets/css/style.css';
@import './assets/css/media.css';
@import './assets/css/aqua.css';
</style>
